export const achievementData = {
    bio : "The illiterate of the 21st century will not be those who cannot read and write, but those who cannot learn, unlearn, and relearn. - Alvin Toffler",
    achievements : [
        {
            id : 1,
            title : 'Paper Presensation  @ 5th APCOG ',
            details : 'Presentation on Emergence of Ovarian Masses after Hysterectomy at State Conference by Obstetrics and Gynaecological Society Of Guntur',
            date : 'Jul 14, 2019',
            field : 'Gynaocology',
            image : 'https://babycatcher-static.s3.ap-south-1.amazonaws.com/imgs/apcob-1.jpeg'
        },
        {
            id : 2,
            title : 'Poster Presentation @ 5th TCOG',
            details : 'Presentation on Ectopic Molar Pregnency - A Rare Entity at Annaul Congress of Telangana State Obstetrics and Gynaecological Society',
            date : 'Aug 4, 2019',
            field : 'Gynaocology',
            image : 'https://babycatcher-static.s3.ap-south-1.amazonaws.com/imgs/apcob-2.jpeg'
        },
        {
            id : 3,
            title : 'CME & Workshop on Critical Care',
            details : 'Workshop on Critical Care - A challenge to the obstetrician',
            date : 'Jul 12, 2019',
            field : 'CriticalCare in Obstetrics',
            image : 'https://babycatcher-static.s3.ap-south-1.amazonaws.com/imgs/kims-1.jpeg'
        },
    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/